import { render, staticRenderFns } from "./IntegrationSport.vue?vue&type=template&id=3772f5eb"
import script from "./IntegrationSport.vue?vue&type=script&lang=js"
export * from "./IntegrationSport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports